// extracted by mini-css-extract-plugin
export var label = "_5z-1";
export var reminder = "_5z-0";